import { render, staticRenderFns } from "./loanBalance.vue?vue&type=template&id=1a9b8991&scoped=true"
import script from "./loanBalance.vue?vue&type=script&lang=js"
export * from "./loanBalance.vue?vue&type=script&lang=js"
import style0 from "./loanBalance.vue?vue&type=style&index=0&id=1a9b8991&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9b8991",
  null
  
)

export default component.exports